import { render, staticRenderFns } from "./injuredForm.vue?vue&type=template&id=3fa69228&scoped=true"
import script from "./injuredForm.vue?vue&type=script&lang=js"
export * from "./injuredForm.vue?vue&type=script&lang=js"
import style0 from "./injuredForm.vue?vue&type=style&index=0&id=3fa69228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa69228",
  null
  
)

export default component.exports